import request from './ajax'
/**
 * 闲置模块接口
 */
const usedUrl = '/api/platform/'
// 淘宝商品列表
// export const getTbGoodsList = (data) => request(usedUrl + 'tb_list', 'post', { ...data })
// 京东商品列表
// export const getJdGoodsList = (data) => request(usedUrl + 'jd_list', 'post', { ...data })


// 淘宝商品列表
export const getTbGoodsList = (data) => request(usedUrl + 'tb_goods', 'post', { ...data })
// 京东商品列表
export const getJdGoodsList = (data) => request(usedUrl + 'jd_goods', 'post', { ...data })
